export default __webpack_public_path__ + "static/media/noorder.25ddf0ec.svg";